import React, { useState, useEffect } from 'react';
import './ColorSelector.css';

const presetColors = [
  '#000000', '#FFFFFF', '#C0C0C0', '#808080', '#0000FF',
  '#FF0000', '#008000', '#8B4513', '#F5F5DC', '#FFFF00',
  '#FFA500', '#800080', '#FF5733', '#33FF57', '#3357FF'
];

function ColorSelector({ value = '', onChange, label = 'Farbe' }) {
  const [selectedColor, setSelectedColor] = useState(value || '#000000');

  useEffect(() => {
    if (value) {
      setSelectedColor(value);
    }
  }, [value]);

  const handleColorChange = (newColor) => {
    setSelectedColor(newColor);
    onChange(newColor);
  };

  return (
    <div className="color-selector">
      <label className="color-selector-label">{label}</label>
      <div className="color-input-group">
        <input
          type="color"
          value={selectedColor}
          onChange={(e) => handleColorChange(e.target.value)}
        />
        <input
          type="text"
          value={selectedColor}
          onChange={(e) => {
            if (/^#[0-9A-Fa-f]{6}$/i.test(e.target.value)) {
              handleColorChange(e.target.value.toUpperCase());
            } else {
              setSelectedColor(e.target.value);
            }
          }}
          onBlur={(e) => {
            if (!/^#[0-9A-Fa-f]{6}$/i.test(e.target.value)) {
              handleColorChange('#000000');
            }
          }}
          placeholder="#000000"
          pattern="^#[0-9A-Fa-f]{6}$"
        />
      </div>
      <div className="preset-colors">
        {presetColors.map(color => (
          <button
            key={color}
            type="button"
            className="preset-color-btn"
            style={{ backgroundColor: color }}
            onClick={() => handleColorChange(color)}
            title={color}
          />
        ))}
      </div>
    </div>
  );
}

export default ColorSelector;
